import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=a80d7f3e&scoped=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"
import style0 from "./CurrencyInput.vue?vue&type=style&index=0&id=a80d7f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80d7f3e",
  null
  
)

export default component.exports